import styled from 'styled-components';

export const StyledTestimonials = styled.section`
  background-color: var(--light-bg);
  position: relative;
  padding: 100px 0;

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  h2 {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 50px;
    color: var(--text-color);
    font-family: Gunar thin, sans-serif;
    font-weight:border-left;
    letter-spacing: 2px;

    .highlight {
      color: var(--primary-color);
    }
  }
`;

export const TestimonialSlider = styled.div`
  position: relative;
  max-width: 800px;
  margin: 0 auto;
`;

export const TestimonialSlide = styled.div`
  display: none;

  &.active {
    display: block;
  }
`;

export const TestimonialContent = styled.div`
  background-color: var(--card-bg);
  border-radius: 8px;
  padding: 40px;
  box-shadow: var(--box-shadow);
  text-align: center;
  position: relative;
  border-top: 4px solid var(--primary-color);

  .quote {
    font-size: 2rem;
    color: var(--primary-color);
    margin-bottom: 20px;
  }

  p {
    font-size: 1.1rem;
    font-style: italic;
    margin-bottom: 30px;
    color: var(--text-color);
  }

  .client {
    font-weight: 600;
    color: var(--primary-color);
  }
`;

export const TestimonialControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

export const PrevBtn = styled.button`
  background-color: transparent;
  border: none;
  font-size: 1.5rem;
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: var(--primary-color);
  }
`;

export const NextBtn = styled.button`
  background-color: transparent;
  border: none;
  font-size: 1.5rem;
  color: var(--text-color);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    color: var(--primary-color);
  }
`;

export const Dots = styled.div`
  display: flex;
  margin: 0 20px;
`;

export const Dot = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--gray-light);
  margin: 0 5px;
  cursor: pointer;
  transition: all 0.3s ease;

  &.active {
    background-color: var(--primary-color);
  }
`;
